module.exports = __webpack_public_path__ + "img/invoice_wechat_icon.e987751e.png";